module.exports = __webpack_public_path__ + "static/media/info_cursor.4876cecb.svg";